import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/me`, {
      credentials: "include"
    })
      .then(res => {
        if (!res.ok) {
          navigate("/login");
        } else {
          setLoading(false);
        }
      });
  }, []);

  if (loading) return <div>Checking auth...</div>;

  return children;
}